<template>
    <entity-list entity="plot" :use-events="false" :team-id="teamId" isArchive></entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
export default {
    name: 'PlotArchive',
    components: {
        'entity-list': EntityList,
    },
    props: {
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
}
</script>
